import { render, staticRenderFns } from "./VerDetalleAlerta.vue?vue&type=template&id=3306d452&"
import script from "./VerDetalleAlerta.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports